<!-- 
 01-01-2025
 Copyright (c) 2016 Aruba. All Rights Reserved.  
 -->
<div class="modal-body">
    <div class="row">
        <div *ngIf="resultText !== ''" class="col-md-12 mb-4 text-center">
            <svg-icon [src]="isSuccess ? svgIconOK : svgIconKO" [svgStyle]="{ 'width.px':'40', 'height.px':'40' }">
            </svg-icon>
        </div>
        <div *ngIf="resultText !== ''" class="col-md-12 font-16 text-center" [innerHTML]="resultText">
            Address verified
        </div>
        <div *ngIf="extraResultText !== ''" class="mt-4  col-md-8 offset-md-2 font-16 {{extraResultClass}}" 
            [innerHTML]="extraResultText" apTextTranslateAnchor (anchorClicked)="onAnchorClicked($event)">
            Extra text
        </div>
        <div *ngIf="extraResultText2 !== ''" class="col-md-12  font-16" [innerHTML]="extraResultText2" 
            apTextTranslateAnchor (anchorClicked)="onAnchorClicked($event)">
            Extra text 2
        </div>
        <div *ngIf="extraErrorMessageText !== ''" class="col-md-12  font-16 text-danger text-center" 
            [innerHTML]="extraErrorMessageText">
            Extra error message
        </div>
        <div class="col-md-12 mt-3 font-16" *ngIf="alertText !== ''" >
            <div class="row g-0 warning-bg py-3">
                <div class="col-2 col-sm-1 text-center ps-3">
                    <svg-icon src="content/images/icons/alert-triangle.svg" 
                        [svgStyle]="{ 'width.px':'22', 'height.px':'22', 'vertical-align': 'top' }"></svg-icon>
                </div>
                <div class="col-md-10 font-14" [innerHTML]="alertText">
                    Extra text alert
                </div>
            </div>
        </div>
        <ng-container *ngIf="isStep2fa">
            <div>
                <div>
                    <div class="font-16 pt-4 ps-2" 
                     [innerHTML]="'accountSecurity.twoFactorAuth.principal.notEnalbe2Fa.titleSmartphone' | translate">
                     Come associare uno smartphone</div>
                    <div class="d-flex justify-content-start mt-3 ms-2">
                        <div class="number">
                            <span class="numberText">{{'accountSecurity.twoFactorAuth.principal.number1' | translate}}
                            </span>
                        </div>
                        <div class="ml-12px" 
                            [innerHTML]="'accountSecurity.twoFactorAuth.principal.notEnalbe2Fa.pointOne' | translate">
                        </div>
                    </div>
                    <hr/>
                    <div class="d-flex justify-content-start mt-3 ms-2">
                        <div class="number">
                            <span class="numberText">{{'accountSecurity.twoFactorAuth.principal.number2' | translate}}
                            </span>
                        </div>
                        <div class="ml-12px mt-1" 
                            [innerHTML]="'accountSecurity.twoFactorAuth.principal.notEnalbe2Fa.pointTwo' | translate">
                        </div>
                    </div>
                    <hr/>
                    <div class="d-flex justify-content-start mt-3 ms-2" *ngIf="!isMultiutente">
                        <div class="number">
                            <span class="numberText">{{'accountSecurity.twoFactorAuth.principal.number3' | translate}}
                            </span>
                        </div>
                        <div class="ml-12px mt-1" 
                           [innerHTML]="'accountSecurity.twoFactorAuth.principal.notEnalbe2Fa.pointThree' | translate">
                        </div>
                    </div>
                    <hr *ngIf="!isMultiutente"/>
                    <div class="d-flex justify-content-start mt-3 ms-2" *ngIf="!isMultiutente">
                        <div class="number">
                            <span class="numberText">{{'accountSecurity.twoFactorAuth.principal.number4' | translate}}
                            </span>
                        </div>
                        <div class="ml-12px mt-1" 
                            [innerHTML]="'accountSecurity.twoFactorAuth.principal.notEnalbe2Fa.pointFour' | translate">
                        </div>
                    </div>
                    <hr *ngIf="!isMultiutente"/>
                    <div class="d-flex justify-content-start mt-3 ms-2">
                        <div class="number"  *ngIf="!isMultiutente">
                            <span class="numberText">{{'accountSecurity.twoFactorAuth.principal.number5' | translate}}
                            </span>
                        </div>
                        <div class="number"  *ngIf="isMultiutente">
                            <span class="numberText">{{'accountSecurity.twoFactorAuth.principal.number3' | translate}}
                            </span>
                        </div>
                        <div class="ml-12px mt-1" 
                            [innerHTML]="'accountSecurity.twoFactorAuth.principal.notEnalbe2Fa.pointFive' | translate">
                        </div>
                    </div>
                    <hr/>
                    <ng-container>
                        <div class="view-ricarica-mobile">
                            <div class="d-flex justify-content-start mt-3 ms-2">
                                    <div class="number"  *ngIf="!isMultiutente">
                                        <span class="numberText">{{'accountSecurity.twoFactorAuth.principal.number6' 
                                            | translate}}</span>
                                    </div>
                                    <div class="number" *ngIf="isMultiutente">
                                        <span class="numberText">{{'accountSecurity.twoFactorAuth.principal.number4' 
                                            | translate}}</span>
                                    </div>
                                    <div class="ml-12px mt-1" 
                                        [innerHTML]="'accountSecurity.twoFactorAuth.principal.notEnalbe2Fa.pointSix' 
                                        | translate">
                                    </div>
                            </div>

                            <div>
                        <button (click)="confirmSubmit()" 
                            class="btn-ricarica-mobile col-lg-4 col-12 btn btn-primary btn-ricarica font-14 ml-12px">
                            {{"accountSecurity.twoFactorAuth.principal.notEnalbe2Fa.pointSixBtn" | translate}} 
                        </button>
                            </div>
                        </div>
                        <div class="view-ricarica-app">
                            <div class="d-flex justify-content-start mt-3 ms-2">
                                <div class="number"  *ngIf="!isMultiutente">
                                    <span class="numberText">{{'accountSecurity.twoFactorAuth.principal.number6' 
                                        | translate}}</span>
                                </div>
                                <div class="number" *ngIf="isMultiutente">
                                    <span class="numberText">{{'accountSecurity.twoFactorAuth.principal.number4' 
                                        | translate}}</span>
                                </div>
                                <div class="ml-12px mt-1" 
                                [innerHTML]="'accountSecurity.twoFactorAuth.principal.notEnalbe2Fa.pointSix' 
                                | translate">
                                </div>
                                <button (click)="confirmSubmit()" class="btn btn-primary btn-ricarica font-14 ml-12px">
                                    {{"accountSecurity.twoFactorAuth.principal.notEnalbe2Fa.pointSixBtn" | translate}} 
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>
</div>
<div class="modal-footer justify-content-center border-top-0 pt-0" *ngIf="btnText && !isStep2fa">
    <button name="confirm" class="btn btn-lg btn-outline-primary px-5" (click)="confirmSubmit()" [innerHTML]="btnText">
    </button>
</div>
<div class="modal-footer justify-content-start" *ngIf="btnText2">
    <button name="confirm" class="btn btn-link p-0" (click)="confirmSubmit()" [innerHTML]="btnText2"></button>
</div>
